
import React from 'react';
import { Button } from '@/components/ui/button';
import { LogIn, Key, Code, RefreshCw } from 'lucide-react';

interface WelcomeHeaderProps {
  isAdmin: boolean;
  isProduction: boolean;
  isDeveloperMode: boolean;
  _lastUpdateTimestamp: number;
  _updateAcknowledged: boolean;
  onLoginClick: () => void;
  onLogoutClick: () => void;
  onChangeCredentialsClick: () => void;
  onToggleDeveloperMode: () => void;
  onForceRefresh: () => void;
}

const WelcomeHeader: React.FC<WelcomeHeaderProps> = ({ 
  isAdmin, 
  isProduction, 
  isDeveloperMode,
  _lastUpdateTimestamp,
  _updateAcknowledged, 
  onLoginClick, 
  onLogoutClick, 
  onChangeCredentialsClick,
  onToggleDeveloperMode,
  onForceRefresh
}) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-8">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-3xl font-bold text-gray-800">Welcome to the Training Resource Center</h1>
        <div className="flex gap-2">
          {!isProduction && (
            <>
              <Button
                variant="outline"
                onClick={onToggleDeveloperMode}
                className={isDeveloperMode ? 
                  "text-green-500 border-green-500 hover:bg-green-500 hover:text-white" : 
                  "text-gray-500 border-gray-500 hover:bg-gray-500 hover:text-white"
                }
              >
                <Code className="mr-2 h-4 w-4" /> {isDeveloperMode ? "Dev Mode: ON" : "Dev Mode: OFF"}
              </Button>
              
              <Button
                variant="outline"
                onClick={onForceRefresh}
                className="text-blue-500 border-blue-500 hover:bg-blue-500 hover:text-white"
              >
                <RefreshCw className="mr-2 h-4 w-4" /> Refresh
              </Button>
            </>
          )}
          
          {isAdmin ? (
            <>
              <Button 
                variant="outline" 
                onClick={onChangeCredentialsClick}
                className="text-brand-blue border-brand-blue hover:bg-brand-blue hover:text-white"
              >
                <Key className="mr-2 h-4 w-4" /> Change Credentials
              </Button>
              <Button 
                variant="outline" 
                onClick={onLogoutClick}
                className="text-red-500 border-red-500 hover:bg-red-500 hover:text-white"
              >
                Logout
              </Button>
            </>
          ) : (
            <Button 
              variant="outline" 
              onClick={onLoginClick}
              className="text-brand-blue border-brand-blue hover:bg-brand-blue hover:text-white"
            >
              <LogIn className="mr-2 h-4 w-4" /> Admin Login
            </Button>
          )}
        </div>
      </div>
      <p className="text-gray-600">
        Find all the resources, documentation, training materials, and guides to help you succeed.
        Browse by category to find exactly what you need.
      </p>
      {!isProduction && (
        <div className="mt-4 p-2 bg-gray-100 rounded-md text-xs text-gray-600">
          <p>Debug info: Last update {new Date(_lastUpdateTimestamp).toLocaleTimeString()}, 
             Acknowledged: {_updateAcknowledged ? 'Yes' : 'No'}</p>
        </div>
      )}
    </div>
  );
};

export default WelcomeHeader;
